
import { defineComponent, ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { GetPdpaMessageResponse, UpsertPdpaMessageRequest } from "@/types";
import { last, set } from "ramda";

export default defineComponent({
  name: "ConfigPdpaScreen",
  setup() {
    const pdpa = ref("");
    const lastUpdateOn = ref<Date | null>();
    const {
      axios,
      error,
      success,
      setLoading,
      dayjs,
      formatAppDateTime,
    } = usePlugin();

    const loadDocument = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetPdpaMessageResponse>(
          "api/v1/services/pdpa"
        );
        success("ดึงข้อมูลสำเร็จแล้ว");

        pdpa.value = result.data.message ?? "";
        lastUpdateOn.value = result.data.updateOn ?? null;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSaveDocument = async (release: boolean) => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/pdpa/upsert", {
          message: pdpa.value,
          updateOn: lastUpdateOn.value,
          release: release,
        } as UpsertPdpaMessageRequest);
        success("บันทึกข้อมูลสำเร็จแล้ว");

        loadDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const lastUpdateOnText = computed(() => {
      if (!lastUpdateOn.value) {
        return "N/A";
      } else {
        return formatAppDateTime(lastUpdateOn.value);
      }
    });
    onMounted(() => loadDocument());

    return { pdpa, lastUpdateOnText, onSaveDocument };
  },
});
